// @owlcat/identity-react — the fleet's shared client-side header identity control.
//
// Usage in an app header:
//   import { ProfileControl } from "@owlcat/identity-react";
//   <ProfileControl
//     accountsUrl={process.env.NEXT_PUBLIC_ACCOUNTS_URL!}
//     profileUrl={accountsProfileUrl(locale)}
//     appsUrl={apexUrl(locale)}
//     returnTo={thisAppUrl}
//     labels={{ signIn, signOut, profile, yourApps, account }}
//   />
export { ProfileControl } from "./ProfileControl";
export { useSelfProfile } from "./useSelfProfile";
// Shared fleet-wide notification-preferences control (ONE global channel +
// per-category on/off toggles). Talks to accounts /notifications/prefs.
export { NotificationSettings } from "./NotificationSettings";
